import { Autocomplete, FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup, TextField, Typography } from "@mui/material";
import React, { memo, useEffect, useState } from "react";
import { useStyle } from "../style";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import moment from "moment";
import { useDispatch } from "react-redux";
import axios from "axios";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import _ from "lodash";

const PurchaseInfo = ({setData,setPostData}) => {
  const classes = useStyle();
  const outlet_id = localStorage.getItem('outlet_id')
  const dispatch = useDispatch()
  const [billData, setBillData] = useState([])
  const [docNo, setDocNo] = useState('')
  const[balance, setBalance] = useState('0.00')
  const [billNo, setBillNo] = useState(null)
  const [address , setAddress] = useState("")
  const [gstIn , setGstIn] = useState("")
  const [isCredit , setIsCredit] = useState("")
  const [partyName , setPartyName] = useState("")
  const[salesManId , setSalesManId] = useState([])
  const[salesMan,setSalesMan] = useState([])
  const [date , setDate] = useState(moment().format('YYYY-MM-DD'))
  const [billdate , setBillDate] = useState(moment().format())
  const outletId = localStorage.getItem('outlet_id')
  const [pay,setPay] = useState(1)
  const [poDetails , setPoDetails] = useState({
  //  partyName : "",
   salesManId : null,
   mobile:""
  })
  const handleChange =(e, name) => {
    if(name==='date'){
      setPoDetails((prevState) =>( {...prevState ,  [name] : dayjs(e).format() }))
    }else{
      setPoDetails((prevState) =>( {...prevState , [name] :  e}))
    }
  }
const handlePayment=(e)=>{
setPay(e.target.value)
}
      function getSalesMan(){
        axios.get('/v1/SalesMan')
        .then(res=>{setSalesMan(res.data);console.log(res.data)})
        .catch(err=>{console.log(err);dispatch(setSnackbar(true,'error',err.response.data.error))})
        }

  function handleBillChange(e, value) {
    console.log(value)
    setBillNo(value);
    
    if (value) {
      
      const selectedBill = billData.find((bill) => bill.docno === value.docno);
      // Update state based on the selected bill
      console.log(selectedBill)
      // setAddress(selectedBill ? (selectedBill.add1 + " " + selectedBill.add2 + "," + selectedBill.city_name + "-" + selectedBill.pincode + "-" + selectedBill.state_name + "-" + selectedBill.country_name) : '');
      setPartyName(value.party_name)
      setGstIn(selectedBill ? selectedBill.gst_in : '');
      setIsCredit(selectedBill ? selectedBill.is_credit : '');
      setBalance(selectedBill ? selectedBill.balance : '0.00')
      setDate(moment().format('YYYY-MM-DD'));
      // setDate(selectedBill ? selectedBill.docdate : moment().format('YYYY-MM-DD'));
      setBillDate(selectedBill ? selectedBill.docdate : moment().format());
      console.log(billData.find((bill) => bill.docno === value.docno))
      // setSalesManId(selectedBill ? selectedBill.salesman_id : 0)
      const saleId = salesMan.find((sale) => sale.id === value.salesman_id)
      console.log(saleId )
      setPoDetails((prev)=>({...prev, salesManId : saleId}))
    } else {
      // Clear values if no bill is selected 
      setAddress('');
      setGstIn('');
      setDate(moment().format('YYYY-MM-DD'));
      setBillDate(moment().format());
    }
  }
  console.log(partyName)
useEffect(() => {
  getSalesMan()
},[])
  useEffect(()=>{
axios.get(`/v1/outlet_sales_return_master/${outletId}`)
.then(res=>setDocNo(res.data.Docno))
.catch(err=> {
  console.log(err)
  dispatch(setSnackbar(true, 'error', err.response.data.error))
})
axios.get(`/v1/outlet_sales_docno/${outlet_id}`)
// axios.get('/v1/sales')
.then(res=>{
  setBillData(res.data)  
  console.log(res.data)
  setData([])
})
.catch(err=>{
  console.log(err)
  dispatch(setSnackbar(true,'error',err.response.data.error))
})
  },[])

  useEffect(()=>{
if(billNo!==null){
  axios.get(`/v1/outlet_sales_return_master/${outletId}/${billNo.docno}`)
  // axios.get(`/v1/sales/${billNo.docno}`)
  
  .then(res=>{
  console.log(res.data)
 const arrData = _.filter(res.data,value=>value.qty!==0).map(item => ({...item, retQty: 0}));
 console.log(arrData )
 if(arrData.length===0){
  setBillNo(null)
  setAddress('');
  setGstIn('');
  setDate(moment().format('YYYY-MM-DD'));
  setBillDate(moment().format());
  setPoDetails((prev)=>({...prev, salesManId : null}))
  setPartyName("")
  setIsCredit("")
  dispatch(setSnackbar(true,'error','No Data Found! '))
 }
 else{
   setData(arrData)
 }
  
  })
  .catch(err=>{
    console.log(err , "hai")
    dispatch(setSnackbar(true,"error", err.response.data.errors[0].message))
  })
}
  },[billNo])
  useEffect(() => {
    if(billNo){
      setPostData((prevState)=>({...prevState,salesman_id:poDetails.salesManId !==null ?poDetails.salesManId?.id : "",outletid: outlet_id, company_id:billNo.company_id,bill_no:billNo.docno,party_name:partyName,address:address,gst_in:gstIn ,is_credit:isCredit,docdate:moment(date).format('YYYY/MM/DD'),mobile:poDetails.mobile, is_cash: Number(pay)}))
    }
  },[billNo,poDetails, pay])
console.log(balance)
  // console.log(poDetails.salesManId.id)
  
  return (
    <Grid container spacing={2} className="p-2 h-full" >
         <Grid item lg={4} >
         <Autocomplete 
        id="billNo"
        name="billNo"
        size="small"
        options={billData}
        getOptionLabel={option=> option.docno}
        onChange={(e,value)=>handleBillChange(e,value)}
        isOptionEqualToValue={(option, value)=> option.docno===value.docno}
        value={billNo}
        renderInput={(params)=>(
          <TextField {...params}
          label='Bill No'/>
        )}
        />
        <TextField size="small" label='Party Name' fullWidth value={partyName} disabled required sx={{marginBlock:1.5}}/>
         {/* <TextField size="small" label='Party Name' disabled fullWidth sx={{marginBlock: 2}} value={partyName}/> */}
          {/* <TextField size="small" label='Address' disabled multiline rows={3.3} fullWidth value={address} sx={{marginBlockEnd:1}}/> */}
         
          <Autocomplete
          id="salesman"
          name="salesman"
          size="small"
          options={salesMan}
          getOptionLabel={(option) => option?.sales_man_name}
          value={poDetails.salesManId}
          // onChange={handleSalesMan}
          disableClearable
          isOptionEqualToValue={(option, value) =>
            option.id === value?.id
          }
          // disabled
          disabled={poDetails.salesManId} // Disable only if no Salesman is prefilled
          onChange={(event, newValue) =>
            setPoDetails((prev) => ({ ...prev, salesManId: newValue }))
          }
          renderInput={(params) => (
            <TextField
              {...params}
              label="Salesman"
              autoComplete="off"
              // required
            />
          )}
  />
   <FormControl sx={{marginTop : 1}}>
    <FormLabel>Payment Method</FormLabel>
                <RadioGroup row onChange={handlePayment} value={pay}>
                  <FormControlLabel value={1} control={<Radio size="small"/>} label="By Cash"/>
                  <FormControlLabel value={0} control={<Radio size="small"/>} label="By Next Bill Adjustment"/>
                </RadioGroup>
              </FormControl>
         </Grid>
        <Grid item lg={4}>
        {/* <TextField
         size="small"
      label="Enter Numbers"
      fullWidth
      sx={{marginBlockEnd:1.5}}
      onChange={(e)=>handleChange(e.target.value,'mobile')}
    /> */}
        <TextField size="small" label='Gstin' disabled  fullWidth value={gstIn} />
          <TextField size="small" label='Is Credit' disabled fullWidth value={isCredit} sx={{marginBlock:1.5}}/>
        <TextField size="small" label='SR No' fullWidth 
        value={docNo.replace("_", "/").replace("_", "-").replace("_", "/")}
        InputProps={{
          readOnly: true,
        }} />
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker value={dayjs(billdate)} label="Date" size="small"  slotProps={{
                  textField: {
                    size: "small",
                  },
                }}
            sx={{width: '100%',marginBlock:1.5}}
          />
        </LocalizationProvider>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker value={dayjs(date)} label="Return Bill Date" size="small"  slotProps={{
                  textField: {
                    size: "small",
                  },
                }}
            sx={{width: '100%',marginBlock:1.5}}
          />
        </LocalizationProvider>
        </Grid>
        <Grid item lg={4}>
              <Typography textAlign="center" variant="h6" sx={{backgroundColor:'#83A2FF',}}>Balance</Typography>
              <Typography textAlign='right' variant="h5" mt={1} sx={{fontWeight:600,}}>{balance}</Typography>

             
        </Grid>
    </Grid>
  );
};

export default memo(PurchaseInfo);
